// extracted by mini-css-extract-plugin
module.exports = {"reviews__item":"s_7","reviews__item__author":"s_8","reviews__item__date":"s_9","reviews__item__stars":"s_bb","reviews__item__star__active":"s_bc","reviews__item__content":"s_bd"};